<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="48" width="48"><g stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :fill="_secondaryfill" :stroke="_secondaryfill"><path d="M31,8h7a6,6,0,0,1,6,6v2" fill="none"></path><polyline points="18 26 3 26 3 3 24 3 24 16" fill="none" :stroke="fill"></polyline><rect x="24" y="22" width="21" height="23" fill="none" :stroke="fill"></rect><polyline points="36 3 31 8 36 13" fill="none"></polyline><path d="M17,40H10a6,6,0,0,1-6-6V32" fill="none"></path><polyline points="12 45 17 40 12 35" fill="none"></polyline></g></svg></template>

<script>
export default {
	props: {
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>